/* Busveilingen.nl — B2B touringcarcalculator
   Stap 1 rit -> Stap 2 prijs -> Stap 3 gegevens

   PRIJS-ENGINE
   Deze module rekent uitsluitend met VERKOOPTARIEVEN. Inkoopprijzen en
   marges staan hier bewust niet in.

   Tariefmodel (per bustype, alle bedragen EXCL. btw):
       prijs = basisbedrag + (tarief per km x afstand enkele reis)

   Retour en enkele reis hebben ieder hun eigen basisbedrag en kilometer-
   tarief. De afstand is de enkele-reisafstand van de hele route, inclusief
   tussenstops. Er wordt daarna NIET nog eens met 2 vermenigvuldigd.

   Automatisch een prijs tonen we alleen voor binnenlandse dagritten binnen
   de ingestelde maximale rijtijd en afstand. Buitenland, meerdaagse ritten,
   zware ritten en groepen boven de maximale bezetting gaan naar
   "prijs op aanvraag".

   Unit tests draaien alleen met ?bvb2btest=1 in de URL. */

(function () {
  'use strict';

  var root = document.getElementById('bvb2b');
  if (!root) return;

  var cfgEl = document.getElementById('bvb2b-config');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }

  function num(v, fallback) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.'));
    return isFinite(n) ? n : fallback;
  }

  /* ---------------- Tariefconfiguratie ---------------- */

  var TARIFFS = {
    maxPassengers: num(CFG.maxPassengers, 88),
    maxTravelHours: num(CFG.maxTravelHours, 2.5),
    maxDistanceKm: num(CFG.maxDistanceKm, 250),
    homeCountry: (CFG.homeCountry || 'NL').toUpperCase(),
    busTypes: (CFG.busTypes || []).map(function (b) {
      return {
        name: b.name,
        maxPassengers: num(b.maxPassengers, 0),
        baseRetour: num(b.baseRetour, 0),
        kmRetour: num(b.kmRetour, 0),
        baseEnkel: num(b.baseEnkel, 0),
        kmEnkel: num(b.kmEnkel, 0),
        minPrice: num(b.minPrice, 0)
      };
    }).filter(function (b) { return b.maxPassengers > 0; })
      .sort(function (a, b) { return a.maxPassengers - b.maxPassengers; })
  };

  /* ---------------- Prijs-engine ---------------- */

  function selectBusType(passengerCount) {
    if (!passengerCount || passengerCount < 1) return null;
    for (var i = 0; i < TARIFFS.busTypes.length; i++) {
      if (passengerCount <= TARIFFS.busTypes[i].maxPassengers) return TARIFFS.busTypes[i];
    }
    return null;
  }

  function calculateSellingPrice(busType, distanceKm, isRetour) {
    var base = isRetour ? busType.baseRetour : busType.baseEnkel;
    var perKm = isRetour ? busType.kmRetour : busType.kmEnkel;
    return Math.max(busType.minPrice, base + (perKm * distanceKm));
  }

  function roundUpToNearestFive(price) {
    return Math.ceil(price / 5) * 5;
  }

  function calculatePricePerPerson(finalPrice, passengerCount) {
    return passengerCount ? finalPrice / passengerCount : 0;
  }

  function foreignCountries(countryCodes) {
    var out = [];
    (countryCodes || []).forEach(function (c) {
      if (!c) return;
      c = String(c).toUpperCase();
      if (c !== TARIFFS.homeCountry && out.indexOf(c) === -1) out.push(c);
    });
    return out;
  }

  function quote(distanceKm, travelTimeHours, passengerCount, isRetour, countryCodes) {
    var busType = selectBusType(passengerCount);
    if (!busType) return { onRequest: true, reason: 'personen' };

    var buitenland = foreignCountries(countryCodes);
    if (buitenland.length) return { onRequest: true, reason: 'buitenland', landen: buitenland };

    if (travelTimeHours > TARIFFS.maxTravelHours) return { onRequest: true, reason: 'rijtijd' };
    if (distanceKm > TARIFFS.maxDistanceKm) return { onRequest: true, reason: 'afstand' };

    var transport = roundUpToNearestFive(calculateSellingPrice(busType, distanceKm, isRetour));

    return {
      onRequest: false,
      busType: busType,
      retour: !!isRetour,
      distanceKm: distanceKm,
      transport: transport
    };
  }

  /* ---------------- state ---------------- */

  var state = {
    tripType: 'retour',
    people: '',
    from: null,
    to: null,
    stops: [],
    outDate: '',
    outTime: '',
    retDate: '',
    retTime: '',
    distanceKm: 0,
    durationMin: 0,
    extras: {},
    price: null,
    manual: false,
    manualReason: ''
  };

  var MAX_STOPS = 5;
  var NEWLINE = String.fromCharCode(10);

  var euro2 = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  var euro0 = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  var dateFmt = new Intl.DateTimeFormat('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });

  function money(v) { return Number.isInteger(v) ? euro0.format(v) : euro2.format(v); }

  var LANDNAMEN = {
    BE: 'België', DE: 'Duitsland', FR: 'Frankrijk', LU: 'Luxemburg', GB: 'het Verenigd Koninkrijk',
    AT: 'Oostenrijk', CH: 'Zwitserland', IT: 'Italië', ES: 'Spanje', DK: 'Denemarken',
    CZ: 'Tsjechië', PL: 'Polen', HU: 'Hongarije'
  };

  function landNaam(code) { return LANDNAMEN[code] || code; }

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  function routeCountries() {
    return [state.from, state.to].concat(state.stops)
      .filter(Boolean)
      .map(function (p) { return p.country || null; });
  }

  /* ---------------- Google Maps laden ---------------- */

  var maps = { places: null, ready: false, failed: false };
  var mapObj = null, directionsRenderer = null, directionsService = null, geocoder = null;

  function loadMaps() {
    if (!CFG.mapsKey) { maps.failed = true; return Promise.resolve(false); }
    if (window.google && window.google.maps && window.google.maps.importLibrary) return bootstrapLibs();

    return new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(CFG.mapsKey) +
        '&v=weekly&libraries=places,routes,geometry&language=nl&region=NL&loading=async&callback=bvb2bMapsReady';
      s.async = true;
      s.onerror = function () { maps.failed = true; resolve(false); };
      window.bvb2bMapsReady = function () { bootstrapLibs().then(resolve); };
      document.head.appendChild(s);
    });
  }

  function bootstrapLibs() {
    return Promise.resolve()
      .then(function () { return google.maps.importLibrary('places'); })
      .then(function (lib) { maps.places = lib; return google.maps.importLibrary('routes'); })
      .then(function () { return google.maps.importLibrary('geocoding'); })
      .then(function () {
        directionsService = new google.maps.DirectionsService();
        geocoder = new google.maps.Geocoder();
        maps.ready = true;
        initAutocompletes();
        return true;
      })
      .catch(function (err) {
        console.warn('[bvb2b] Google Maps kon niet geladen worden', err);
        maps.failed = true;
        return false;
      });
  }

  /* ---------------- Adres-autocomplete ---------------- */

  var sessionToken = null;
  var newPlacesBroken = false;

  function newSession() {
    try {
      if (maps.places && maps.places.AutocompleteSessionToken) {
        sessionToken = new maps.places.AutocompleteSessionToken();
      }
    } catch (e) { sessionToken = null; }
  }

  function newPlacesSuggestions(input) {
    var req = { input: input, language: 'nl', region: 'nl' };
    if (CFG.countries && CFG.countries.length) req.includedRegionCodes = CFG.countries;
    if (sessionToken) req.sessionToken = sessionToken;
    return maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(req)
      .then(function (res) {
        return (res.suggestions || []).map(function (s) {
          var p = s.placePrediction;
          if (!p) return null;
          return {
            main: p.mainText ? p.mainText.text : p.text.text,
            secondary: p.secondaryText ? p.secondaryText.text : '',
            full: p.text ? p.text.text : '',
            place: p.toPlace ? p.toPlace() : null,
            placeId: p.placeId
          };
        }).filter(Boolean);
      });
  }

  function legacySuggestions(input) {
    if (!maps.places || !maps.places.AutocompleteService) return Promise.resolve([]);
    return new Promise(function (resolve) {
      var svc = new maps.places.AutocompleteService();
      var opts = { input: input, language: 'nl' };
      if (CFG.countries && CFG.countries.length) opts.componentRestrictions = { country: CFG.countries.slice(0, 5) };
      svc.getPlacePredictions(opts, function (preds) {
        resolve((preds || []).map(function (p) {
          return {
            main: p.structured_formatting ? p.structured_formatting.main_text : p.description,
            secondary: p.structured_formatting ? p.structured_formatting.secondary_text : '',
            full: p.description,
            place: null,
            placeId: p.place_id
          };
        }));
      });
    });
  }

  function fetchSuggestions(input) {
    var lib = maps.places;
    var hasNew = !newPlacesBroken && lib && lib.AutocompleteSuggestion &&
      lib.AutocompleteSuggestion.fetchAutocompleteSuggestions;

    if (hasNew) {
      return newPlacesSuggestions(input).catch(function () {
        newPlacesBroken = true;
        return legacySuggestions(input);
      });
    }
    return legacySuggestions(input);
  }

  function countryFromComponents(components) {
    if (!components || !components.length) return null;
    for (var i = 0; i < components.length; i++) {
      var c = components[i];
      var types = c.types || [];
      if (types.indexOf('country') > -1) {
        return (c.shortText || c.short_name || '').toUpperCase() || null;
      }
    }
    return null;
  }

  function resolveSuggestion(sug) {
    if (sug.place && sug.place.fetchFields) {
      return sug.place.fetchFields({ fields: ['location', 'formattedAddress', 'displayName', 'addressComponents'] })
        .then(function (r) {
          var pl = r.place || sug.place;
          var loc = pl.location;
          return {
            text: pl.formattedAddress || sug.full,
            lat: typeof loc.lat === 'function' ? loc.lat() : loc.lat,
            lng: typeof loc.lng === 'function' ? loc.lng() : loc.lng,
            placeId: sug.placeId,
            country: countryFromComponents(pl.addressComponents)
          };
        })
        .catch(function () { return geocodeText(sug.full); });
    }
    return geocodeText(sug.full).then(function (r) {
      return r || { text: sug.full, lat: null, lng: null, placeId: sug.placeId, country: null };
    });
  }

  function geocodeText(text) {
    if (!geocoder) return Promise.resolve(null);
    return new Promise(function (resolve) {
      geocoder.geocode({ address: text, region: 'nl' }, function (res, status) {
        if (status === 'OK' && res && res[0]) {
          resolve({
            text: res[0].formatted_address,
            lat: res[0].geometry.location.lat(),
            lng: res[0].geometry.location.lng(),
            placeId: res[0].place_id,
            country: countryFromComponents(res[0].address_components)
          });
        } else resolve(null);
      });
    });
  }

  function attachAutocomplete(wrap) {
    if (wrap.dataset.acBound === 'true') return;
    wrap.dataset.acBound = 'true';

    var input = $('.bvb2b__ac-input', wrap);
    var list = $('.bvb2b__suggest', wrap);
    var key = wrap.dataset.acKey;
    var timer = null;
    var items = [];
    var activeIdx = -1;

    function target(val) {
      if (key === 'from') { state.from = val; }
      else if (key === 'to') { state.to = val; }
      else { state.stops[parseInt(wrap.dataset.stopIndex, 10)] = val; }
    }

    function close() { list.hidden = true; activeIdx = -1; }

    function render() {
      if (!items.length) { close(); return; }
      list.innerHTML = '';
      items.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.idx = String(i);
        b.innerHTML = '<span>' + escapeHtml(s.main) + '</span>' +
          (s.secondary ? '<small>' + escapeHtml(s.secondary) + '</small>' : '');
        list.appendChild(b);
      });
      list.hidden = false;
    }

    function pick(i) {
      var s = items[i];
      if (!s) return;
      input.value = s.full;
      input.classList.remove('bvb2b__input--invalid');
      close();
      resolveSuggestion(s).then(function (val) { target(val); newSession(); });
    }

    input.addEventListener('input', function () {
      target(null);
      var v = input.value.trim();
      clearTimeout(timer);
      if (v.length < 3 || !maps.ready) { close(); return; }
      if (!sessionToken) newSession();
      timer = setTimeout(function () {
        fetchSuggestions(v).then(function (res) { items = res.slice(0, 6); render(); })
          .catch(function () { close(); });
      }, 180);
    });

    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      var btns = $$('button', list);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIdx += (e.key === 'ArrowDown' ? 1 : -1);
        if (activeIdx < 0) activeIdx = btns.length - 1;
        if (activeIdx >= btns.length) activeIdx = 0;
        btns.forEach(function (b, i) { b.dataset.active = String(i === activeIdx); });
      } else if (e.key === 'Enter') {
        if (activeIdx > -1) { e.preventDefault(); pick(activeIdx); }
      } else if (e.key === 'Escape') { close(); }
    });

    list.addEventListener('mousedown', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      e.preventDefault();
      pick(parseInt(b.dataset.idx, 10));
    });

    input.addEventListener('blur', function () { setTimeout(close, 150); });
  }

  function initAutocompletes() { $$('.bvb2b__ac').forEach(attachAutocomplete); }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Tussenstops ---------------- */

  var stopsWrap = $('#bvb2b-stops');
  var addStopBtn = $('#bvb2b-add-stop');

  function renderStops() {
    stopsWrap.innerHTML = '';
    state.stops.forEach(function (stop, i) {
      var row = document.createElement('div');
      row.className = 'bvb2b__stop-row';
      row.innerHTML =
        '<div class="bvb2b__ac" data-ac-key="stop" data-stop-index="' + i + '">' +
        '  <label class="bvb2b__label" for="bvb2b-stop-' + i + '">Tussenstop ' + (i + 1) + '</label>' +
        '  <div style="position:relative">' +
        '    <svg class="bvb2b__pin" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle></svg>' +
        '    <input id="bvb2b-stop-' + i + '" class="bvb2b__input bvb2b__ac-input" type="text" autocomplete="off" placeholder="Bijv. Den Haag Centraal" value="' + escapeHtml(stop && stop.text ? stop.text : '') + '">' +
        '  </div>' +
        '  <div class="bvb2b__suggest" hidden></div>' +
        '</div>' +
        '<button type="button" class="bvb2b__iconbtn" data-remove-stop="' + i + '" aria-label="Tussenstop verwijderen">&times;</button>';
      stopsWrap.appendChild(row);
    });
    if (maps.ready) initAutocompletes();
    addStopBtn.hidden = state.stops.length >= MAX_STOPS;
  }

  addStopBtn.addEventListener('click', function () {
    if (state.stops.length >= MAX_STOPS) return;
    state.stops.push(null);
    renderStops();
    var last = stopsWrap.querySelector('.bvb2b__stop-row:last-child input');
    if (last) last.focus();
  });

  stopsWrap.addEventListener('click', function (e) {
    var b = e.target.closest('[data-remove-stop]');
    if (!b) return;
    state.stops.splice(parseInt(b.dataset.removeStop, 10), 1);
    renderStops();
  });

  /* ---------------- Ritsoort ---------------- */

  var retourFields = $('#bvb2b-retour-fields');

  $$('#bvb2b-triptype button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.tripType = btn.dataset.value;
      $$('#bvb2b-triptype button').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      retourFields.hidden = state.tripType !== 'retour';
    });
  });

  /* ---------------- Datum/tijd ---------------- */

  var elOutDate = $('#bvb2b-out-date');
  var elOutTime = $('#bvb2b-out-time');
  var elRetDate = $('#bvb2b-ret-date');
  var elRetTime = $('#bvb2b-ret-time');
  var elPeople = $('#bvb2b-people');

  (function setMinDates() {
    var d = new Date();
    d.setDate(d.getDate() + (num(CFG.minLeadDays, 1)));
    var iso = d.toISOString().slice(0, 10);
    elOutDate.min = iso;
    elRetDate.min = iso;
  })();

  elOutDate.addEventListener('change', function () {
    if (!elRetDate.value || elRetDate.value < elOutDate.value) elRetDate.value = elOutDate.value;
    elRetDate.min = elOutDate.value;
  });

  /* ---------------- Validatie ---------------- */

  function setError(id, msg) {
    var el = $('#' + id);
    if (!el) return;
    el.textContent = msg || '';
    el.dataset.show = msg ? 'true' : 'false';
  }

  function collect() {
    state.people = parseInt(elPeople.value, 10) || 0;
    state.outDate = elOutDate.value;
    state.outTime = elOutTime.value;
    state.retDate = elRetDate.value;
    state.retTime = elRetTime.value;
  }

  function validateStep1() {
    collect();
    var ok = true;
    var fromInput = $('[data-ac-key="from"] .bvb2b__ac-input');
    var toInput = $('[data-ac-key="to"] .bvb2b__ac-input');

    setError('bvb2b-err-people', '');
    setError('bvb2b-err-from', '');
    setError('bvb2b-err-to', '');
    setError('bvb2b-err-when', '');

    if (!state.people || state.people < 1) { setError('bvb2b-err-people', 'Vul het aantal personen in.'); ok = false; }
    if (!fromInput.value.trim()) { setError('bvb2b-err-from', 'Vul een vertrekadres in.'); fromInput.classList.add('bvb2b__input--invalid'); ok = false; }
    else fromInput.classList.remove('bvb2b__input--invalid');
    if (!toInput.value.trim()) { setError('bvb2b-err-to', 'Vul een bestemming in.'); toInput.classList.add('bvb2b__input--invalid'); ok = false; }
    else toInput.classList.remove('bvb2b__input--invalid');
    if (!state.outDate || !state.outTime) { setError('bvb2b-err-when', 'Kies een vertrekdatum en -tijd.'); ok = false; }
    if (state.tripType === 'retour' && (!state.retDate || !state.retTime)) {
      setError('bvb2b-err-when', 'Kies ook een datum en tijd voor de terugreis.'); ok = false;
    }
    return ok;
  }

  /* ---------------- Route berekenen ---------------- */

  function ensurePoint(val, inputEl) {
    if (val && val.lat != null) return Promise.resolve(val);
    var text = inputEl ? inputEl.value.trim() : (val && val.text) || '';
    if (!text) return Promise.resolve(null);
    return geocodeText(text).then(function (r) { return r || { text: text, lat: null, lng: null, country: null }; });
  }

  function buildRoute() {
    var fromInput = $('[data-ac-key="from"] .bvb2b__ac-input');
    var toInput = $('[data-ac-key="to"] .bvb2b__ac-input');
    var stopInputs = $$('[data-ac-key="stop"] .bvb2b__ac-input');

    return ensurePoint(state.from, fromInput)
      .then(function (f) { state.from = f; return ensurePoint(state.to, toInput); })
      .then(function (t) { state.to = t; })
      .then(function () {
        var chain = Promise.resolve();
        state.stops.forEach(function (s, i) {
          chain = chain.then(function () {
            return ensurePoint(s, stopInputs[i]).then(function (r) { state.stops[i] = r; });
          });
        });
        return chain;
      })
      .then(function () {
        if (!state.from || state.from.lat == null || !state.to || state.to.lat == null) {
          throw new Error('geen-coordinaten');
        }
        return directions();
      });
  }

  function directions() {
    if (!directionsService) throw new Error('geen-directions');
    var waypoints = state.stops.filter(function (s) { return s && s.lat != null; })
      .map(function (s) { return { location: new google.maps.LatLng(s.lat, s.lng), stopover: true }; });

    var req = {
      origin: new google.maps.LatLng(state.from.lat, state.from.lng),
      destination: new google.maps.LatLng(state.to.lat, state.to.lng),
      waypoints: waypoints,
      travelMode: google.maps.TravelMode.DRIVING,
      region: 'nl',
      language: 'nl'
    };

    return new Promise(function (resolve, reject) {
      directionsService.route(req, function (res, status) {
        if (status !== 'OK' || !res || !res.routes || !res.routes[0]) return reject(new Error('route-mislukt:' + status));
        var meters = 0, seconds = 0;
        res.routes[0].legs.forEach(function (leg) {
          meters += leg.distance ? leg.distance.value : 0;
          seconds += leg.duration ? leg.duration.value : 0;
        });
        state.distanceKm = meters / 1000;
        state.durationMin = seconds / 60;
        resolve(res);
      });
    });
  }

  function drawMap(result) {
    var el = $('#bvb2b-map');
    if (!el) return;
    if (!mapObj) {
      mapObj = new google.maps.Map(el, {
        zoom: 7,
        center: { lat: 52.1, lng: 5.3 },
        disableDefaultUI: true,
        zoomControl: true,
        gestureHandling: 'cooperative'
      });
      directionsRenderer = new google.maps.DirectionsRenderer({
        map: mapObj,
        suppressMarkers: false,
        polylineOptions: { strokeColor: '#013167', strokeWeight: 5, strokeOpacity: 0.9 }
      });
    }
    directionsRenderer.setMap(mapObj);
    directionsRenderer.setDirections(result);
    setTimeout(function () { google.maps.event.trigger(mapObj, 'resize'); }, 250);
  }

  /* ---------------- Prijs samenstellen ---------------- */

  function multiDay() {
    return state.tripType === 'retour' && state.retDate && state.outDate && state.retDate !== state.outDate;
  }

  function extrasTotal() {
    var sum = 0;
    (CFG.extras || []).forEach(function (x, i) {
      if (state.extras['e' + i]) sum += num(x.price, 0);
    });
    return sum;
  }

  function computePrice() {
    var q = quote(
      state.distanceKm,
      state.durationMin / 60,
      state.people,
      state.tripType === 'retour',
      routeCountries()
    );
    if (q.onRequest) return q;
    var extras = extrasTotal();
    var total = q.transport + extras;
    return {
      onRequest: false,
      busType: q.busType,
      retour: q.retour,
      transport: q.transport,
      extras: extras,
      total: total,
      perPerson: calculatePricePerPerson(total, state.people)
    };
  }

  /* ---------------- Panelen ---------------- */

  function showPanel(name) {
    $$('.bvb2b__panel').forEach(function (p) { p.hidden = p.dataset.panel !== name; });
    var order = { step1: 1, step2: 2, step3: 3, done: 4 };
    var idx = order[name] || 1;
    $$('.bvb2b__step').forEach(function (s) {
      var n = parseInt(s.dataset.step, 10);
      s.setAttribute('aria-current', n === idx ? 'step' : 'false');
      s.dataset.done = String(n < idx);
    });
    var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  /* ---------------- Stap 1 -> 2 ---------------- */

  var calcBtn = $('#bvb2b-calc');
  var calcLabel = calcBtn.innerHTML;

  calcBtn.addEventListener('click', function () {
    if (!validateStep1()) return;

    if (state.people > TARIFFS.maxPassengers) {
      return goManual('Voor groepen boven ' + TARIFFS.maxPassengers + ' personen stellen wij de prijs handmatig samen, zodat we de juiste combinatie touringcars kunnen inzetten.');
    }
    if (multiDay()) {
      return goManual('Voor meerdaagse reizen maken we een offerte op maat, inclusief overnachting en verblijf van de chauffeur.');
    }

    calcBtn.disabled = true;
    calcBtn.innerHTML = '<span class="bvb2b__loading"><span class="bvb2b__spin"></span> Prijs berekenen...</span>';

    var work = maps.ready ? Promise.resolve(true) : loadMaps();

    work.then(function () {
      if (!maps.ready) throw new Error('maps-niet-beschikbaar');
      return buildRoute();
    })
      .then(function (res) {
        var p = computePrice();
        if (p.onRequest) {
          var e = new Error(p.reason);
          e.landen = p.landen;
          throw e;
        }
        state.price = p;
        renderStep2();
        drawMap(res);
        showPanel('step2');
        track('B2B prijs berekend');
      })
      .catch(function (err) {
        var msg = String(err && err.message);
        var reason = 'We konden voor deze rit niet automatisch een prijs berekenen.';
        if (msg.indexOf('buitenland') > -1) {
          var landen = (err.landen || []).map(landNaam);
          reason = 'Deze rit gaat naar ' + (landen.length ? landen.join(' en ') : 'het buitenland') +
            '. Voor buitenlandse ritten maken wij een offerte op maat, inclusief tol, milieuzones en de inzet van de chauffeur.';
        } else if (msg.indexOf('rijtijd') > -1) {
          reason = 'Deze rit duurt langer dan ' + formatDuration(TARIFFS.maxTravelHours * 60) + ' enkele reis. Daarvoor stellen we een offerte op maat samen, met de juiste chauffeursinzet.';
        } else if (msg.indexOf('afstand') > -1) {
          reason = 'Deze rit is langer dan ' + TARIFFS.maxDistanceKm + ' km enkele reis. Daarvoor stellen we een offerte op maat samen.';
        } else if (msg.indexOf('personen') > -1) {
          reason = 'Voor deze groepsgrootte stellen wij de prijs handmatig samen.';
        } else if (msg.indexOf('geen-coordinaten') > -1) {
          reason = 'We konden een van de adressen niet vinden. Laat uw gegevens achter, dan sturen we de offerte handmatig.';
        }
        goManual(reason);
      })
      .then(function () {
        calcBtn.disabled = false;
        calcBtn.innerHTML = calcLabel;
      });
  });

  function goManual(reason) {
    state.manual = true;
    state.price = null;
    state.manualReason = reason;
    var note = $('#bvb2b-manual-note');
    note.innerHTML = '<span>&#9432;</span><span><strong>Prijs op aanvraag.</strong> ' + escapeHtml(reason) +
      ' Laat hieronder uw gegevens achter, dan ontvangt u binnen 24 uur een offerte op maat.</span>';
    note.hidden = false;
    $('#bvb2b-price-block').hidden = true;
    fillHidden();
    showPanel('step3');
    calcBtn.disabled = false;
    calcBtn.innerHTML = calcLabel;
    track('B2B prijs op aanvraag');
  }

  /* ---------------- Stap 2 renderen ---------------- */

  function renderStep2() {
    var p = state.price;

    $('#bvb2b-total').textContent = money(p.total);
    $('#bvb2b-pp').textContent = euro2.format(p.perPerson);
    $('#bvb2b-pp-label').textContent = 'Prijs p.p. (' + state.people + ' personen)';
    $('#bvb2b-bustype').textContent = p.busType.name;

    var meta = $('#bvb2b-meta');
    meta.innerHTML = '';
    addMeta(meta, iconBus(), p.busType.name + ' — ' + (state.tripType === 'retour' ? 'retour' : 'enkele reis'));
    addMeta(meta, iconUsers(), state.people + ' personen');
    addMeta(meta, iconRoute(), Math.round(state.distanceKm) + ' km enkele reis, ongeveer ' + formatDuration(state.durationMin) + ' rijtijd');

    var path = $('#bvb2b-path');
    path.innerHTML = '';
    path.appendChild(legBlock('Heenreis', state.outDate, state.outTime, false));
    if (state.tripType === 'retour') {
      path.appendChild(legBlock('Terugreis', state.retDate, state.retTime, true));
    }

    renderExtras();
  }

  function formatDuration(min) {
    min = Math.round(min);
    if (min < 60) return min + ' min';
    var h = Math.floor(min / 60), m = min % 60;
    return h + ' u' + (m ? ' ' + m + ' min' : '');
  }

  function addMeta(ul, svg, text) {
    var li = document.createElement('li');
    li.innerHTML = svg + '<span>' + escapeHtml(text) + '</span>';
    ul.appendChild(li);
  }

  function legBlock(title, date, time, reverse) {
    var wrap = document.createElement('div');
    wrap.className = 'bvb2b__leg';
    var when = '';
    if (date) {
      var d = new Date(date + 'T00:00:00');
      when = dateFmt.format(d) + (time ? ' - vertrek ' + time : '');
    }
    var points = [state.from].concat(state.stops.filter(Boolean)).concat([state.to]);
    if (reverse) points = points.slice().reverse();

    var html = '<div class="bvb2b__leg-title">' + title + ' <span class="bvb2b__leg-when">' + escapeHtml(when) + '</span></div><div class="bvb2b__path">';
    points.forEach(function (pt, i) {
      var cls = i === 0 ? 'bvb2b__dot' : (i === points.length - 1 ? 'bvb2b__dot bvb2b__dot--end' : 'bvb2b__dot bvb2b__dot--via');
      html += '<div class="bvb2b__path-item"><span class="' + cls + '"></span><span>' + escapeHtml(pt && pt.text ? pt.text : '') + '</span></div>';
    });
    html += '</div>';
    wrap.innerHTML = html;
    return wrap;
  }

  function renderExtras() {
    var grid = $('#bvb2b-extras');
    var wrap = $('#bvb2b-extras-wrap');
    if (!grid) return;
    var list = CFG.extras || [];
    if (!list.length) { if (wrap) wrap.hidden = true; return; }
    if (wrap) wrap.hidden = false;
    grid.innerHTML = '';
    list.forEach(function (x, i) {
      var on = !!state.extras['e' + i];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bvb2b__extra';
      b.setAttribute('aria-pressed', String(on));
      b.dataset.extra = 'e' + i;
      b.innerHTML =
        '<span class="bvb2b__extra-top"><span class="bvb2b__extra-name">' + escapeHtml(x.title) + '</span>' +
        '<span class="bvb2b__extra-price">+ ' + money(num(x.price, 0)) + '</span></span>' +
        '<span class="bvb2b__extra-state">' + (on ? 'Toegevoegd' : 'Toevoegen') + '</span>';
      grid.appendChild(b);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.bvb2b__extra') : null;
    if (!b || !root.contains(b)) return;
    state.extras[b.dataset.extra] = !state.extras[b.dataset.extra];
    var p = computePrice();
    if (!p.onRequest) { state.price = p; renderStep2(); }
  });

  /* ---------------- Navigatie ---------------- */

  $$('[data-goto]').forEach(function (b) {
    b.addEventListener('click', function () { showPanel(b.dataset.goto); });
  });

  $('#bvb2b-to-details').addEventListener('click', function () {
    if (!state.price) return;
    state.manual = false;
    $('#bvb2b-manual-note').hidden = true;
    $('#bvb2b-price-block').hidden = false;
    $('#bvb2b-confirm-total').textContent = money(state.price.total);
    $('#bvb2b-confirm-sub').textContent = state.price.busType.name + ' - ' +
      (state.tripType === 'retour' ? 'retour' : 'enkele reis') + ' - ' +
      state.people + ' personen - ' + Math.round(state.distanceKm) + ' km';
    fillHidden();
    showPanel('step3');
    track('B2B gegevens gestart');
  });

  $$('[data-forward="details"]').forEach(function (b) {
    b.addEventListener('click', function () { $('#bvb2b-to-details').click(); });
  });

  /* ---------------- Verzenden ---------------- */

  function summaryText() {
    var lines = [];
    lines.push('AANVRAAG BUSVERVOER (B2B)');
    lines.push('Ritsoort: ' + (state.tripType === 'retour' ? 'Retour' : 'Enkele reis'));
    lines.push('Aantal personen: ' + state.people);
    lines.push('Van: ' + (state.from && state.from.text ? state.from.text : ''));
    state.stops.filter(Boolean).forEach(function (s, i) { lines.push('Tussenstop ' + (i + 1) + ': ' + s.text); });
    lines.push('Naar: ' + (state.to && state.to.text ? state.to.text : ''));
    lines.push('Vertrek: ' + state.outDate + ' ' + state.outTime);
    if (state.tripType === 'retour') lines.push('Terugreis: ' + state.retDate + ' ' + state.retTime);
    if (state.distanceKm) lines.push('Afstand enkele reis: ' + Math.round(state.distanceKm) + ' km (ongeveer ' + formatDuration(state.durationMin) + ')');

    var landen = foreignCountries(routeCountries());
    if (landen.length) lines.push('Buitenland: ' + landen.map(landNaam).join(', '));

    var chosen = (CFG.extras || []).filter(function (x, i) { return state.extras['e' + i]; })
      .map(function (x) { return x.title + ' (' + money(num(x.price, 0)) + ')'; });
    if (chosen.length) lines.push('Extras: ' + chosen.join(', '));

    if (state.manual || !state.price) {
      lines.push('PRIJS: op aanvraag - ' + state.manualReason);
    } else {
      lines.push('Bustype: ' + state.price.busType.name);
      lines.push('Transport: ' + money(state.price.transport) + ' excl. btw');
      if (state.price.extras) lines.push('Extras: ' + money(state.price.extras) + ' excl. btw');
      lines.push('TOTAALPRIJS excl. btw: ' + money(state.price.total));
      lines.push('Prijs p.p.: ' + euro2.format(state.price.perPerson) + ' excl. btw');
    }
    return lines.join(NEWLINE);
  }

  function fillHidden() {
    var f = $('#bvb2b-form');
    if (!f) return;
    var set = function (name, value) {
      var el = f.querySelector('[name="contact[' + name + ']"]');
      if (el) el.value = value == null ? '' : String(value);
    };
    set('Ritsoort', state.tripType === 'retour' ? 'Retour' : 'Enkele reis');
    set('Aantal personen', state.people);
    set('Bustype', state.price ? state.price.busType.name : 'Op aanvraag');
    set('Vertrekadres', state.from && state.from.text ? state.from.text : '');
    set('Bestemming', state.to && state.to.text ? state.to.text : '');
    set('Tussenstops', state.stops.filter(Boolean).map(function (s) { return s.text; }).join(' | '));
    set('Vertrek', state.outDate + ' ' + state.outTime);
    set('Terugreis', state.tripType === 'retour' ? state.retDate + ' ' + state.retTime : '-');
    set('Afstand km', state.distanceKm ? Math.round(state.distanceKm) : '-');
    set('Berekende prijs', state.manual || !state.price ? 'Op aanvraag' : money(state.price.total) + ' excl. btw');
    set('Samenvatting', summaryText());
  }

  var form = $('#bvb2b-form');
  if (form) {
    form.addEventListener('submit', function () {
      fillHidden();
      var val = function (n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el ? el.value : ''; };
      var email = val('email'), name = val('Contactpersoon'), company = val('Bedrijf'), phone = val('Telefoon');
      identify(email, name, company, phone);
      track('B2B offerte aangevraagd', {
        ritsoort: state.tripType,
        personen: state.people,
        bustype: state.price ? state.price.busType.name : null,
        van: state.from && state.from.text,
        naar: state.to && state.to.text,
        tussenstops: state.stops.filter(Boolean).map(function (s) { return s.text; }),
        vertrek: state.outDate + ' ' + state.outTime,
        terugreis: state.tripType === 'retour' ? state.retDate + ' ' + state.retTime : null,
        afstand_km: state.distanceKm ? Math.round(state.distanceKm) : null,
        buitenland: foreignCountries(routeCountries()),
        prijs_excl_btw: state.price ? state.price.total : null,
        prijs_op_aanvraag: !state.price,
        bedrijf: company,
        telefoon: phone,
        samenvatting: summaryText()
      });
    });
  }

  /* ---------------- Klaviyo ---------------- */

  function klaviyo() {
    window._learnq = window._learnq || [];
    return window._learnq;
  }

  function identify(email, name, company, phone) {
    if (!email) return;
    try {
      klaviyo().push(['identify', {
        $email: email,
        $first_name: (name || '').split(' ')[0] || '',
        $last_name: (name || '').split(' ').slice(1).join(' '),
        $organization: company || '',
        $phone_number: phone || ''
      }]);
    } catch (e) {}
  }

  function track(event, props) {
    try { klaviyo().push(['track', event, props || {}]); } catch (e) {}
    try {
      if (window.dataLayer) window.dataLayer.push({ event: 'bvb2b_' + event.toLowerCase().split(' ').join('_') });
    } catch (e) {}
  }

  /* ---------------- Iconen ---------------- */

  function iconBus() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="4" width="18" height="12" rx="2"></rect><path d="M3 10h18"></path><circle cx="7.5" cy="18.5" r="1.5"></circle><circle cx="16.5" cy="18.5" r="1.5"></circle></svg>';
  }
  function iconUsers() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="8" r="3.2"></circle><path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5"></path><path d="M16 11.5a3 3 0 1 0-1.2-5.7"></path><path d="M17 14.5c2.2.5 3.7 2.2 3.7 4.5"></path></svg>';
  }
  function iconRoute() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="6" cy="6" r="2.5"></circle><circle cx="18" cy="18" r="2.5"></circle><path d="M8.5 6H14a3.5 3.5 0 0 1 0 7h-4a3.5 3.5 0 0 0 0 7h5.5"></path></svg>';
  }

  /* ---------------- Unit tests (alleen met ?bvb2btest=1) ---------------- */

  function runTests() {
    var NL = ['NL', 'NL'];
    var cases = [
      { naam: 'Utrecht -> Nieuwegein 5,8 km, retour, 50 pers', km: 5.8, min: 10, pers: 50, retour: true, land: NL, verwacht: 785 },
      { naam: 'Utrecht -> Amersfoort 29,7 km, retour, 50 pers', km: 29.7, min: 27, pers: 50, retour: true, land: NL, verwacht: 845 },
      { naam: 'Utrecht -> Den Bosch 56,6 km, retour, 50 pers', km: 56.6, min: 42, pers: 50, retour: true, land: NL, verwacht: 915 },
      { naam: 'Utrecht -> Eindhoven 87,7 km, retour, 50 pers', km: 87.7, min: 62, pers: 50, retour: true, land: NL, verwacht: 990 },
      { naam: 'Utrecht -> Maastricht 177,4 km, retour, 50 pers', km: 177.4, min: 127, pers: 50, retour: true, land: NL, verwacht: 1215 },
      { naam: 'Utrecht -> Maastricht 177,4 km, enkele reis, 50 pers', km: 177.4, min: 127, pers: 50, retour: false, land: NL, verwacht: 640 },
      { naam: 'Eindhoven retour, 60 pers', km: 87.7, min: 62, pers: 60, retour: true, land: NL, verwacht: 1070 },
      { naam: 'Eindhoven retour, 80 pers (dubbeldekker)', km: 87.7, min: 62, pers: 80, retour: true, land: NL, verwacht: 1170 },
      { naam: '89 personen -> op aanvraag', km: 50, min: 40, pers: 89, retour: true, land: NL, verwacht: 'op aanvraag' },
      { naam: 'Bestemming in Belgie -> op aanvraag', km: 150, min: 110, pers: 50, retour: true, land: ['NL', 'BE'], verwacht: 'op aanvraag' },
      { naam: 'Tussenstop in Duitsland -> op aanvraag', km: 150, min: 110, pers: 50, retour: true, land: ['NL', 'NL', 'DE'], verwacht: 'op aanvraag' },
      { naam: 'Rijtijd 4 uur -> op aanvraag', km: 340, min: 240, pers: 50, retour: true, land: NL, verwacht: 'op aanvraag' },
      { naam: 'Onbekend land -> gewoon een prijs', km: 50, min: 40, pers: 50, retour: true, land: [null, null], verwacht: 895 }
    ];

    var rows = cases.map(function (c) {
      var q = quote(c.km, c.min / 60, c.pers, c.retour, c.land);
      var uitkomst = q.onRequest ? 'op aanvraag' : q.transport;
      var pp = q.onRequest ? '-' : Math.round((q.transport / c.pers) * 100) / 100;
      return {
        test: c.naam,
        bustype: q.onRequest ? '-' : q.busType.name,
        reden: q.onRequest ? q.reason : '-',
        uitkomst: uitkomst,
        verwacht: c.verwacht,
        pp: pp,
        geslaagd: String(uitkomst) === String(c.verwacht) ? 'JA' : 'NEE'
      };
    });

    console.log('%cBusveilingen B2B prijs-engine — unit tests', 'font-weight:bold');
    console.table(rows);
    var mislukt = rows.filter(function (r) { return r.geslaagd === 'NEE'; });
    console.log(mislukt.length ? mislukt.length + ' test(s) MISLUKT' : 'Alle tests geslaagd.');
    window.bvb2bTestResults = rows;
  }

  /* ---------------- Start ---------------- */

  renderStops();

  if (document.getElementById('bvb2b-posted')) {
    showPanel('done');
    track('B2B offerte verzonden');
  } else if (document.getElementById('bvb2b-haserrors')) {
    $('#bvb2b-price-block').hidden = true;
    showPanel('step3');
  }

  if (/[?&]bvb2btest=1/.test(window.location.search)) runTests();

  loadMaps().then(function () {
    if (maps.failed) {
      var n = $('#bvb2b-maps-warn');
      if (n) n.hidden = false;
    }
  });
})();